import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // React Router for navigation
import "./PopupBanner.css";

const PopupBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const navigate = useNavigate(); // Use React Router's navigate function

  useEffect(() => {
    // Check if the banner has been seen before
    const bannerSeen = localStorage.getItem("adBannerSeen");
    if (!bannerSeen) {
      setShowBanner(true); // Show the banner if not seen
    }

    // Add event listener to close banner when clicking outside
    const handleOutsideClick = (e) => {
      if (e.target.classList.contains("popup-banner")) {
        setShowBanner(false);
        localStorage.setItem("adBannerSeen", "true");
      }
    };

    window.addEventListener("click", handleOutsideClick);

    return () => {
      window.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const handleClose = () => {
    setShowBanner(false); // Close the banner
    localStorage.setItem("adBannerSeen", "true"); // Mark banner as seen
  };

  const handleRedirect = () => {
    navigate("/training");
    handleClose(); // Redirect to the Training page
  };

  if (!showBanner) {
    return null; // Don't render if the banner shouldn't be shown
  }

  return (
    <div className="popup-banner">
      <div className="popup-content">
        <button className="btn-close" onClick={handleClose}>
          ✖
        </button>
        <div className="image-container">
          <img
            src="./images/banners/Feb.png" // Replace with your image path
            alt="Advertisement"
            className="ad-image"
          />
          <button className="ad-button" onClick={handleRedirect}>
            Learn More
          </button>
        </div>
      </div>
    </div>
  );
};

export default PopupBanner;
